import React, { type FC } from "react";

import { type Filters } from "../../../utils/queryUtils";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getEventFilters } from "./eventFilters";

export interface EventFilterFormForPacksProps {
  filterOptions: Filters;
  updateFilter: (filter: Filters) => void;
  filter: Filters;
}
export const EventFilterFormForPacks: FC<EventFilterFormForPacksProps> = ({ filterOptions, filter, updateFilter }) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getEventFilters(false)}
  />
);
